import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    tagsBox: {
        whiteSpace: "normal",
        margin: theme.spacing(3, 0, 3, 0),
        display: "flex",
        flexWrap: "wrap",
        height: "auto",
        gap: theme.spacing(1),
        maxWidth: 600,
        alignItems: "center",
    },
    actionBox: {
        display: "flex",
        gap: theme.spacing(2),
        justifyContent: "flex-end",
    },
    channelSelect: {
        minWidth: 120,
        height: 40,
        display: "flex",
        justifyContent: "flex-start",
        "& .MuiInput-formControl": {
            marginTop: 0,
        },
    },
    popover: {
        padding: 0,
        borderRadius: theme.spacing(2),
        minWidth: 280,
        maxWidth: 400,
    },
    popoverHeader: {
        padding: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
        backgroundColor: theme.palette.emteria.background.paper,
    },
    popoverContent: {
        padding: theme.spacing(3),
    },
    artifactItem: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(1),
        transition: "background-color 0.2s ease",
        textDecoration: "none",
        color: theme.palette.emteria.text.primary,
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.paperDeep,
        },
        "&:last-child": {
            marginBottom: 0,
        },
    },
    artifactItemDisabled: {
        opacity: 0.5,
        cursor: "default",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    artifactIcon: {
        width: 20,
        height: 20,
        marginRight: theme.spacing(2),
        color: theme.palette.emteria.primary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    artifactName: {
        flex: 1,
        fontWeight: 500,
    },
    exportSection: {
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.emteria.border.primary}`,
        display: "flex",
        justifyContent: "flex-end",
    },
    exportButton: {
        padding: theme.spacing(2),
        textTransform: "none",
        fontWeight: 500,
    },
    oldConfigIcon: {
        color: theme.palette.emteria.warning,
        fontSize: 16,
        marginLeft: theme.spacing(2),
    },
    actionContainer: {
        display: "flex",
        zIndex: 100,
        flexDirection: "column",
    },
}));
